// extracted by mini-css-extract-plugin
module.exports = {"team":"TeamSection_team__3qu5v","members":"TeamSection_members__z_rXz"};